<template>
    <div class="container" id="content">
        <!-- 导航栏 -->
        <div style="width:100%;height:100%; ">
            <section id="zz" v-if="isZH" style="height:1080px;position: relative;padding:0 104px;box-sizing:border-box;">
                <div class="flex-row-between" style="position: relative;width:100%;height: 140px;">
                    <img src="../../static/b/logo.png" alt=""  style="width:140px;">
                    <div class="flex-row-center">
                        <div @click="isZH=!isZH" class="lang">{{isZH?'En':'Zh'}}</div>
                        <div class="flex-column-center" style="width:75px;height:80px;margin-left:20px;cursor: pointer;" @click="showNav=!showNav">
                            <img src="../../static/b/menu.png" alt="" style="width:45px;">
                        </div>
                    </div>
                    <div v-if="showNav" class="flex-column-between" style="width: 282px;height: 355px;padding:34px 40px;box-sizing:border-box;position:absolute;right:0px;top:120px;background: #B5ED3D;border-radius: 20px;">
                        <div v-for="(item,index) in navbar" :key="index" @click="scrollTo(item.id)" 
                            @mouseenter="navActive=item.id" @mouseleave="navActive=''"
                            style="align-self:flex-start;" :class="['nav',navActive==item.id ? 'nav-active' : '']">{{item[isZH?'zh':'en']}}</div>
                    </div>
                </div>
                <div class="flex-row-between" style="width:100%;margin-top: 120px;font-family: Manrope, Manrope;">
                    <div style="color: #FFFFFF;font-weight: bold;">
                        <div style="font-size: 200px;">Best Way</div>
                        <div style="font-size: 100px;">數字營銷與 IT 解決方案<br>專家</div>
                    </div>
                     <div style="width:340px;color: #FEF3F3;font-weight: 400;margin-top: 60px;">
                        <div style="font-size: 28px;line-height: 40px;">立足香港，爲企業提昇<br>品牌影響力與運營效率</div>
                        <div style="width:100%;height:1px;background:#FEF3F3;margin-top:36px;">&nbsp;</div>
                    </div>
                </div>
                <img src="../../static/b/banner-icon.png" alt=""  style="width:120px;position: absolute;right:200px;bottom:-60px;">
            </section>
            <section id="zz" v-else style="height:1080px;position: relative;padding:0 104px;box-sizing:border-box;">
                <div class="flex-row-between" style="position: relative;width:100%;height: 140px;">
                    <img src="../../static/b/logo.png" alt=""  style="width:140px;">
                    <div class="flex-row-center">
                        <div @click="isZH=!isZH" class="lang">{{isZH?'En':'Zh'}}</div>
                        <div class="flex-column-center" style="width:75px;height:80px;margin-left:20px;cursor: pointer;" @click="showNav=!showNav">
                            <img src="../../static/b/menu.png" alt="" style="width:45px;">
                        </div>
                    </div>
                    <div v-if="showNav" class="flex-column-between" style="width: 282px;height: 355px;padding:34px 40px;box-sizing:border-box;position:absolute;right:0px;top:120px;background: #B5ED3D;border-radius: 20px;">
                        <div v-for="(item,index) in navbar" :key="index" @click="scrollTo(item.id)" 
                            @mouseenter="navActive=item.id" @mouseleave="navActive=''"
                            style="align-self:flex-start;" :class="['nav',navActive==item.id ? 'nav-active' : '']">{{item[isZH?'zh':'en']}}</div>
                    </div>
                </div>
                <div class="flex-row-between" style="width:100%;margin-top: 120px;font-family: Manrope, Manrope;">
                    <div style="color: #FFFFFF;font-weight: bold;">
                        <div style="font-size: 200px;">Best Way</div>
                        <div style="font-size: 100px;">Digital Marketing & IT <br>Solutions Experts</div>
                    </div>
                     <div style="width:340px;color: #FEF3F3;font-weight: 400;margin-top: 60px;">
                        <div style="font-size: 28px;line-height: 32px;">Based in Hong Kong, we <br>help enterprises amplify <br>brand influence and <br>streamline operations.</div>
                        <div style="width:100%;height:1px;background:#FEF3F3;margin-top:36px;">&nbsp;</div>
                    </div>
                </div>
                <img src="../../static/b/banner-icon.png" alt=""  style="width:120px;position: absolute;right:200px;bottom:-60px;">
            </section>
        </div>

        <!-- 公司簡介 -->
        <div style="width:100%; height:100%; overflow: hidden;margin-top:120px;">
            <section id="aa" v-if="isZH" class="flex-row-between" style="position: relative;padding: 0 140px;box-sizing:border-box;">
                <div style="flex:1;width:100%;height:100%;;box-sizing:border-box;">
                    <div class="flex-row-between">
                        <div class="flex-column-center" style="justify-content: flex-start;margin-right:114px;">
                            <div class="main-t" style="">公司簡介</div>
                            <div class="main-c" style="width:100%;">Best Way Consultant Limited</div>  
                            <div class="sub-c">是一家在香港注冊的專業諮詢與技術服務機構，專注於數字化營銷與信息技術解決方案，助力企業提昇品牌影響力與運營效率。</div>
                        </div>
                        <img src="../../static/b/banner1.png" alt=""  style="height:512px;">
                    </div>
                    <div class="flex-row-between" v-for="(item,index) in jjList" :key="index" :style="{marginTop:'100px'}">
                        <div style="width:600px; height: 100%;text-align:left;">
                            <img :src="require(`../../static/b/jj${index+1}.png`)" alt="" style="width: 100%;height: 336px;">
                        </div>
                        <div class="flex-column-center" :style="{flex:1,marginLeft:'120px',}">
                            <div class="sub-t" v-for="(child,ind) in item.zh.split('<br>')" :key="ind">{{child}}</div>  
                            <div class="sub-c" v-for="(child,ind) in item.cZh.split('<br>')" :key="ind">{{child}}</div>  
                        </div>
                    </div>
                </div>
            </section>
            <section id="aa" v-else class="flex-row-between" style="position: relative;padding: 0 140px;box-sizing:border-box;">
                <div style="flex:1;width:100%;height:100%;;box-sizing:border-box;">
                    <div class="flex-row-between">
                        <div class="flex-column-center" style="justify-content: flex-start;margin-right:114px;">
                            <div class="main-t" style="">About Best Way Consultant Limited</div>
                            <div class="main-c" style="width:100%;">Best Way Consultant Limited</div>  
                            <div class="sub-c">is a professional consulting and technology services organization registered in Hong Kong, specializing in digital marketing and information technology solutions to help companies improve brand impact and operational efficiency.</div>
                        </div>
                        <img src="../../static/b/banner1.png" alt=""  style="height:512px;">
                    </div>
                    <div class="flex-row-between" v-for="(item,index) in jjList" :key="index" :style="{marginTop:'100px'}">
                        <div style="width:600px; height: 100%;text-align:left;">
                            <img :src="require(`../../static/b/jj${index+1}.png`)" alt="" style="width: 100%;height: 336px;">
                        </div>
                        <div class="flex-column-center" :style="{flex:1,marginLeft:'120px',}">
                            <div class="sub-t" v-for="(child,ind) in item.en.split('<br>')" :key="ind">{{child}}</div>  
                            <div class="sub-c" v-for="(child,ind) in item.cEn.split('<br>')" :key="ind">{{child}}</div>  
                        </div>
                    </div>
                </div>
            </section>
        </div>
        
        <!-- 我們的優勢 -->
        <div style="width:100%; height:980px; overflow: hidden;background: #1A1A1A;margin-top:260px;">
            <section id="bb" v-if="isZH" class="flex-row-between" style="position: relative;padding: 159px 0;box-sizing:border-box;">
                <div style="flex:1;width:100%;height:100%;">
                    <div class="flex-column-center" style="justify-content: flex-start;margin-bottom:80px;padding: 0 140px;box-sizing:border-box;">
                        <div class="main-t" style="color: #FFFFFF;">我們的優勢</div>
                    </div>
                    <swiper ref="mySwiper" :options="swiperOption" class="horizontal-swiper" style="padding: 0 40px;box-sizing:border-box;">
                        <swiper-slide>
                            <div class="flex-row-between" style="width:100%;height:540px;background: #F1F4F8;border-radius: 40px;"> 
                                <div class="flex-column-center" style="width:100%;padding-left:90px;position:relative;margin-right: 150px;">
                                    <div style="align-self:flex-start;padding:20px 60px;font-family: Manrope, Manrope;font-weight: bold;font-size: 56px;color: #1A1A1A;border-radius: 100px;border: 2px solid #1A1A1A;margin-bottom:42px;" 
                                        v-for="(item,index) in ysList[0].zh.split('<br>')" :key="index">{{item}}</div>  
                                    <div class="sub-c" style="font-weight: 400;font-size: 56px;color: #1A1A1A;line-height: 72px;" 
                                        v-for="(item,index) in ysList[0].cZh.split('<br>')" :key="index">{{item}}</div>  
                                    <div class="swiper-button-next" style="position: absolute;right:-150px;top:50%;" v-show="activeIndex==0" @click="activeIndex=1">
                                        <img src="../../static/b/banner-icon.png" alt=""  style="width:120px;transform: rotate(270deg);">
                                    </div>
                                </div>
                            </div>
                        </swiper-slide>
                        <swiper-slide>
                            <div class="flex-row-between" style="width:100%;height:540px;background: #F1F4F8;border-radius: 40px;"> 
                                <div class="flex-column-center" style="width:100%;padding-left:90px;position:relative;margin-right: 150px;">
                                    <div style="align-self:flex-start;padding:20px 60px;font-family: Manrope, Manrope;font-weight: bold;font-size: 56px;color: #1A1A1A;border-radius: 100px;border: 2px solid #1A1A1A;margin-bottom:42px;" 
                                        v-for="(item,index) in ysList[1].zh.split('<br>')" :key="index">{{item}}</div>  
                                    <div class="sub-c" style="font-weight: 400;font-size: 56px;color: #1A1A1A;line-height: 72px;" 
                                        v-for="(item,index) in ysList[1].cZh.split('<br>')" :key="index">{{item}}</div>  
                                    <div class="swiper-button-prev" style="position: absolute;left:0;top:50%;">
                                        <img src="../../static/b/banner-icon.png" alt=""  style="width:120px;transform: rotate(90deg);" v-show="activeIndex==1" @click="activeIndex=0">
                                    </div>
                                    <div class="swiper-button-next" style="position: absolute;right:-150px;top:50%;" v-show="activeIndex==1" @click="activeIndex=2">
                                        <img src="../../static/b/banner-icon.png" alt=""  style="width:120px;transform: rotate(270deg);">
                                    </div>
                                </div>
                            </div>
                        </swiper-slide>
                        <swiper-slide>
                            <div class="flex-row-between" style="width:100%;height:540px;background: #F1F4F8;border-radius: 40px;"> 
                                <div class="flex-column-center" style="width:100%;padding-left:90px;position:relative;margin-right: 150px;">
                                    <div style="align-self:flex-start;padding:20px 60px;font-family: Manrope, Manrope;font-weight: bold;font-size: 56px;color: #1A1A1A;border-radius: 100px;border: 2px solid #1A1A1A;margin-bottom:42px;" 
                                        v-for="(item,index) in ysList[2].zh.split('<br>')" :key="index">{{item}}</div>  
                                    <div class="sub-c" style="font-weight: 400;font-size: 56px;color: #1A1A1A;line-height: 72px;" 
                                        v-for="(item,index) in ysList[2].cZh.split('<br>')" :key="index">{{item}}</div>  
                                    <div class="swiper-button-prev" style="position: absolute;left:0;top:50%;" v-show="activeIndex==2" @click="activeIndex=1">
                                        <img src="../../static/b/banner-icon.png" alt=""  style="width:120px;transform: rotate(90deg);">
                                    </div>
                                </div>
                            </div>
                        </swiper-slide>
                    </swiper>
                </div>
            </section>
            <section id="bb" v-else class="flex-row-between" style="position: relative;padding: 159px 0;box-sizing:border-box;">
                <div style="flex:1;width:100%;height:100%;">
                    <div class="flex-column-center" style="justify-content: flex-start;margin-bottom:80px;padding: 0 140px;box-sizing:border-box;">
                        <div class="main-t" style="color: #FFFFFF;">Our Advantages</div>
                    </div>
                    <swiper ref="mySwiper" :options="swiperOption" class="horizontal-swiper" style="padding: 0 40px;box-sizing:border-box;">
                        <swiper-slide>
                            <div class="flex-row-between" style="width:100%;height:540px;background: #F1F4F8;border-radius: 40px;"> 
                                <div class="flex-column-center" style="width:100%;padding-left:90px;position:relative;margin-right: 150px;">
                                    <div style="align-self:flex-start;padding:20px 60px;font-family: Manrope, Manrope;font-weight: bold;font-size: 56px;color: #1A1A1A;border-radius: 100px;border: 2px solid #1A1A1A;margin-bottom:42px;" 
                                        v-for="(item,index) in ysList[0].en.split('<br>')" :key="index">{{item}}</div>  
                                    <div class="sub-c" style="font-weight: 400;font-size: 56px;color: #1A1A1A;line-height: 72px;" 
                                        v-for="(item,index) in ysList[0].cEn.split('<br>')" :key="index">{{item}}</div>  
                                    <div class="swiper-button-next" style="position: absolute;right:-150px;top:50%;" v-show="activeIndex==0" @click="activeIndex=1">
                                        <img src="../../static/b/banner-icon.png" alt=""  style="width:120px;transform: rotate(270deg);">
                                    </div>
                                </div>
                            </div>
                        </swiper-slide>
                        <swiper-slide>
                            <div class="flex-row-between" style="width:100%;height:540px;background: #F1F4F8;border-radius: 40px;"> 
                                <div class="flex-column-center" style="width:100%;padding-left:90px;position:relative;margin-right: 150px;">
                                    <div style="align-self:flex-start;padding:20px 60px;font-family: Manrope, Manrope;font-weight: bold;font-size: 56px;color: #1A1A1A;border-radius: 100px;border: 2px solid #1A1A1A;margin-bottom:42px;" 
                                        v-for="(item,index) in ysList[1].en.split('<br>')" :key="index">{{item}}</div>  
                                    <div class="sub-c" style="font-weight: 400;font-size: 56px;color: #1A1A1A;line-height: 72px;" 
                                        v-for="(item,index) in ysList[1].cEn.split('<br>')" :key="index">{{item}}</div>  
                                    <div class="swiper-button-prev" style="position: absolute;left:0;top:50%;">
                                        <img src="../../static/b/banner-icon.png" alt=""  style="width:120px;transform: rotate(90deg);" v-show="activeIndex==1" @click="activeIndex=0">
                                    </div>
                                    <div class="swiper-button-next" style="position: absolute;right:-150px;top:50%;" v-show="activeIndex==1" @click="activeIndex=2">
                                        <img src="../../static/b/banner-icon.png" alt=""  style="width:120px;transform: rotate(270deg);">
                                    </div>
                                </div>
                            </div>
                        </swiper-slide>
                        <swiper-slide>
                            <div class="flex-row-between" style="width:100%;height:540px;background: #F1F4F8;border-radius: 40px;"> 
                                <div class="flex-column-center" style="width:100%;padding-left:90px;position:relative;margin-right: 150px;">
                                    <div style="align-self:flex-start;padding:20px 60px;font-family: Manrope, Manrope;font-weight: bold;font-size: 56px;color: #1A1A1A;border-radius: 100px;border: 2px solid #1A1A1A;margin-bottom:42px;" 
                                        v-for="(item,index) in ysList[2].en.split('<br>')" :key="index">{{item}}</div>  
                                    <div class="sub-c" style="font-weight: 400;font-size: 56px;color: #1A1A1A;line-height: 72px;" 
                                        v-for="(item,index) in ysList[2].cEn.split('<br>')" :key="index">{{item}}</div>  
                                    <div class="swiper-button-prev" style="position: absolute;left:0;top:50%;" v-show="activeIndex==2" @click="activeIndex=1">
                                        <img src="../../static/b/banner-icon.png" alt=""  style="width:120px;transform: rotate(90deg);">
                                    </div>
                                </div>
                            </div>
                        </swiper-slide>
                    </swiper>
                </div>
            </section>
        </div>

        <!-- 核心價值觀 -->
        <div style="width:100%; overflow: hidden;background: #fff;color:#000;margin-top:120px;">
            <section id="cc" v-if="isZH" style="position:relative;width:100%;padding: 0 140px;box-sizing: border-box;">
                <div class="flex-column-center" style="width:100%;">
                    <div class="main-t">核心價值觀</div>
                </div>
                <div class="flex-row-between" style="width:100%;margin-top:100px;align-items:flex-start;">
                    <div style="width:calc(50% - 65px);flex-flow:row wrap;">
                        <div class="flex-column-center" style="width:100%;">
                            <img :src="require(`../../static/b/wh1.png`)" alt="" style="width:100%;">
                            <div class="sub-t" style="width:100%;text-align:left;margin-top:56px;color: #222222;">{{whList[0].zh}}</div>
                            <div style="height:200px;">
                                <div class="sub-c" v-for="(child,ind) in whList[0].cZh.split('<br>')" :key="ind">{{child}}</div>
                            </div>
                        </div>
                        <div class="flex-column-center" style="width:100%;">
                            <img :src="require(`../../static/b/wh3.png`)" alt="" style="width:100%;">
                            <div class="sub-t" style="width:100%;text-align:left;margin-top:56px;color: #222222;">{{whList[2].zh}}</div>  
                            <div class="sub-c" v-for="(child,ind) in whList[2].cZh.split('<br>')" :key="ind">{{child}}</div>
                        </div>
                    </div>
                    <div style="width:calc(50% - 65px);flex-flow:row wrap;">
                        <div class="flex-column-center" style="width:100%;">
                            <img :src="require(`../../static/b/wh2.png`)" alt="" style="width:100%;">
                            <div class="sub-t" style="width:100%;text-align:left;margin-top:56px;color: #222222;">{{whList[1].zh}}</div>  
                            <div style="height:250px;">
                                <div class="sub-c" v-for="(child,ind) in whList[1].cZh.split('<br>')" :key="ind">{{child}}</div>
                            </div>
                        </div>
                        <div class="flex-column-center" style="width:100%;">
                            <img :src="require(`../../static/b/wh4.png`)" alt="" style="width:100%;">
                            <div class="sub-t" style="width:100%;text-align:left;margin-top:56px;color: #222222;">{{whList[3].zh}}</div>  
                            <div class="sub-c" v-for="(child,ind) in whList[3].cZh.split('<br>')" :key="ind">{{child}}</div>
                        </div>
                    </div>
                </div>
            </section>
            <section id="cc" v-else style="position:relative;width:100%;padding: 0 140px;box-sizing: border-box;">
                <div class="flex-column-center" style="width:100%;">
                    <div class="main-t">Core Values</div>
                </div>
                <div class="flex-row-between" style="width:100%;margin-top:100px;align-items:flex-start;">
                    <div style="width:calc(50% - 65px);flex-flow:row wrap;">
                        <div class="flex-column-center" style="width:100%;">
                            <img :src="require(`../../static/b/wh1.png`)" alt="" style="width:100%;">
                            <div class="sub-t" style="width:110%;align-self:flex-start;text-align:left;margin-top:56px;color: #222222;">{{whList[0].en}}</div>
                            <div style="height:300px;">
                                <div class="sub-c" v-for="(child,ind) in whList[0].cEn.split('<br>')" :key="ind">{{child}}</div>
                            </div>
                        </div>
                        <div class="flex-column-center" style="width:100%;">
                            <img :src="require(`../../static/b/wh3.png`)" alt="" style="width:100%;">
                            <div class="sub-t" style="width:110%;align-self:flex-start;text-align:left;margin-top:56px;color: #222222;">{{whList[2].en}}</div>  
                            <div class="sub-c" v-for="(child,ind) in whList[2].cEn.split('<br>')" :key="ind">{{child}}</div>
                        </div>
                    </div>
                    <div style="width:calc(50% - 65px);flex-flow:row wrap;">
                        <div class="flex-column-center" style="width:100%;">
                            <img :src="require(`../../static/b/wh2.png`)" alt="" style="width:100%;">
                            <div class="sub-t" style="width:110%;align-self:flex-start;text-align:left;margin-top:56px;color: #222222;">{{whList[1].en}}</div>  
                            <div style="height:350px;">
                                <div class="sub-c" v-for="(child,ind) in whList[1].cEn.split('<br>')" :key="ind">{{child}}</div>
                            </div>
                        </div>
                        <div class="flex-column-center" style="width:100%;">
                            <img :src="require(`../../static/b/wh4.png`)" alt="" style="width:100%;">
                            <div class="sub-t" style="width:110%;align-self:flex-start;text-align:left;margin-top:56px;color: #222222;">{{whList[3].en}}</div>  
                            <div class="sub-c" v-for="(child,ind) in whList[3].cEn.split('<br>')" :key="ind">{{child}}</div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
        
        <!-- 业务介绍 -->
        <div style="width:100%; height: 100%; overflow: hidden;background: #fff;margin-top:200px;">
            <section id="dd" v-if="isZH" style="">
                <div style="width:100%; height: 100%;position: absolute;z-index: 20;padding: 0 140px;box-sizing: border-box;">
                    <div v-for="(item,index) in ywList" :key="index">
                        <div class="flex-row-between" v-if="ywActive%2==index" style="width:100%;height:100%;background: #F1F4F8;border-radius: 40px;"> 
                            <div class="flex-column-center" style="flex:1;padding-left:70px;">
                                <div class="sub-t" v-for="(child,ind) in item.zh.split('<br>')" :key="ind">{{child}}</div>  
                                <div style="margin-bottom: 5px;">&nbsp;</div>
                                <div class="sub-c" v-for="(child,ind) in item.cZh.split('<br>')" :key="ind">
                                    <span v-if="ind>0" style="display:inline-block;width:7px;height:7px;background:#A4A4A4;border-radius:50%;margin:0 7px;vertical-align:middle;">&nbsp;</span>
                                    {{child}}
                                </div>  
                            </div>
                            <img :src="require(`../../static/b/yw${index+1}.png`)" alt="" style="height:600px;">
                        </div>
                    </div>
                    <div class="flex-row-center" style="width:100%;padding: 80px 0px;box-sizing: border-box;">
                        <div style="width: 120px; height: 120px;margin:0 14px;" @mouseenter="hoverLeft=true" @mouseleave="hoverLeft=false" @click="ywActive-=1">
                            <img :src="require(`../../static/b/arrow-left.png`)" alt="" v-show="!hoverLeft" style="width:120px;">
                            <img :src="require(`../../static/b/arrow-right.png`)" alt="" v-show="hoverLeft" style="width:120px;transform: rotate(180deg);">
                        </div>
                        <div style="width: 120px; height: 120px;margin:0 14px;" @mouseenter="hoverRight=true" @mouseleave="hoverRight=false" @click="ywActive+=1">
                            <img :src="require(`../../static/b/arrow-left.png`)" alt="" v-show="!hoverRight" style="width:120px;transform: rotate(180deg);">
                            <img :src="require(`../../static/b/arrow-right.png`)" alt="" v-show="hoverRight" style="width:120px;">
                        </div>
                    </div>
                </div>
                <div class="black-background"></div>
            </section>
            <section id="dd" v-else style="">
                <div style="width:100%; height: 100%;position: absolute;z-index: 20;padding: 0 140px;box-sizing: border-box;">
                    <div v-for="(item,index) in ywList" :key="index">
                        <div class="flex-row-between" v-if="ywActive%2==index" style="width:100%;height:100%;background: #F1F4F8;border-radius: 40px;"> 
                            <div class="flex-column-center" style="flex:1;padding-left:70px;align-self:flex-start;padding-top: 60px;box-sizing: border-box;">
                                <div class="sub-t" style="font-size:50px;line-height: 70px;" v-for="(child,ind) in item.en.split('<br>')" :key="ind">{{child}}</div>  
                                <div style="margin-bottom: 0px;">&nbsp;</div>
                                <div class="sub-c" style="font-size:24px;line-height: 32px;" v-for="(child,ind) in item.cEn.split('<br>')" :key="ind">
                                    <span v-if="ind>0" style="display:inline-block;width:7px;height:7px;background:#A4A4A4;border-radius:50%;margin:0 7px;vertical-align:middle;">&nbsp;</span>
                                    {{child}}
                                </div>  
                            </div>
                            <img :src="require(`../../static/b/yw${index+1}.png`)" alt="" style="height:600px;">
                        </div>
                    </div>
                    <div class="flex-row-center" style="width:100%;padding: 80px 0px;box-sizing: border-box;">
                        <div style="width: 120px; height: 120px;margin:0 14px;" @mouseenter="hoverLeft=true" @mouseleave="hoverLeft=false" @click="ywActive-=1">
                            <img :src="require(`../../static/b/arrow-left.png`)" alt="" v-show="!hoverLeft" style="width:120px;">
                            <img :src="require(`../../static/b/arrow-right.png`)" alt="" v-show="hoverLeft" style="width:120px;transform: rotate(180deg);">
                        </div>
                        <div style="width: 120px; height: 120px;margin:0 14px;" @mouseenter="hoverRight=true" @mouseleave="hoverRight=false" @click="ywActive+=1">
                            <img :src="require(`../../static/b/arrow-left.png`)" alt="" v-show="!hoverRight" style="width:120px;transform: rotate(180deg);">
                            <img :src="require(`../../static/b/arrow-right.png`)" alt="" v-show="hoverRight" style="width:120px;">
                        </div>
                    </div>
                </div>
                <div class="black-background"></div>
            </section>
        </div>
        

        <!-- 聯繫我們 -->
        <div style="width:100%;height: 500px; overflow: hidden;background: #B5ED3D;color:#fff;box-sizing:border-box;font-family: Manrope, Manrope;">
            <section id="ee" v-if="isZH" class="flex-column-between" style="position:relative;width:100%;height:100%;padding: 0 130px;box-sizing:border-box;">
                <div class="flex-row-between" style="width:100%;align-items: flex-start;margin-top:50px;align-items: flex-start;font-family: Manrope, Manrope;color: #fff;">
                    <div style="font-weight: 600;font-size: 52px;line-height: 170px;">contact@bestway-cons.com</div>
                    <div style="width:200px;background: #FFFFFF;border-radius: 100px;position:relative;align-self:flex-start;padding: 0 0px 0 30px;box-sizing:border-box;margin-top:55px;">
                        <span style="display:inline-block;font-family: Manrope, Manrope;font-weight: 400;font-size: 22px;color: #000;line-height: 60px;">聯繫我們</span>
                        <img :src="require(`../../static/b/arrow.png`)" alt="" style="width:44px;position:absolute;top:8px;right:8px;">
                    </div>
                </div>
                <div class="flex-row-between" style="width:100%;height: 74px;margin-top:0px;font-weight: 500;color: #fff;">
                    <div style="font-size: 54px;">Best Way.</div>
                    <div style="font-size: 25px;font-family: Inter, Inter;font-weight: 400;color: #fff;align-self:flex-end;">
                        <span v-for="(item,index) in navbar" :key="index" style="margin-left: 50px;" @click="scrollTo(item.id)">{{item[isZH?'zh':'en']}}</span>
                    </div>
                </div>
                <div style="width:100%;height:1px;background:#fff;margin-top:40px;">&nbsp;</div>
                <div style="height:128px;line-height: 128px;font-family: Inter, Inter;font-weight: 400;font-size: 26px;color: #fff;text-align: center;">Best Way 數字營銷與 IT 解決方案專家</div>
            </section>
            <section id="ee" v-else class="flex-column-between" style="position:relative;width:100%;height:100%;padding: 0 130px;box-sizing:border-box;">
                <div class="flex-row-between" style="width:100%;align-items: flex-start;margin-top:50px;font-family: Manrope, Manrope;color: #fff;">
                    <div style="font-weight: 600;font-size: 52px;line-height: 170px;">contact@bestway-cons.com</div>
                    <div style="width:230px;background: #FFFFFF;border-radius: 100px;position:relative;align-self:flex-start;padding: 0 0px 0 30px;box-sizing:border-box;margin-top:55px;">
                        <span style="display:inline-block;font-family: Manrope, Manrope;font-weight: 400;font-size: 22px;color: #000;line-height: 60px;">Contact Us</span>
                        <img :src="require(`../../static/b/arrow.png`)" alt="" style="width:44px;position:absolute;top:8px;right:8px;">
                    </div>
                </div>
                <div class="flex-row-between" style="width:100%;height: 74px;margin-top:0px;font-weight: 500;color: #fff;">
                    <div style="font-size: 54px;">Best Way.</div>
                    <div style="font-size: 25px;font-family: Inter, Inter;font-weight: 400;color: #fff;align-self:flex-end;">
                        <span v-for="(item,index) in navbar" :key="index" style="margin-left: 50px;" @click="scrollTo(item.id)">{{item[isZH?'zh':'en']}}</span>
                    </div>
                </div>
                <div style="width:100%;height:1px;background:#fff;margin-top:40px;">&nbsp;</div>
                <div style="height:128px;line-height: 128pxfont-family: Inter, Inter;font-weight: 400;font-size: 26px;color: #fff;text-align: center;">Best Way Digital Marketing & IT Solutions Experts</div>
            </section>
        </div>
        
    </div>
</template>
<script>

import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.min.css";
import autofit from 'autofit.js'
export default {
    name: 'Index',
    components: {
        Swiper,
        SwiperSlide,
    },
    data() {
        return {
            activeIndex: 0,
            swiperOption: {
                navigation: {
                    nextEl: ".swiper-button-next", // 下一个按钮的类名
                    prevEl: ".swiper-button-prev", // 上一个按钮的类名
                    hiddenClass: "my-button-hidden",//隐藏时的class
                    disabledClass: 'my-button-disabled',//不可用时的class
                },
                // slidesPerView: '2',
                // centeredSlides: true,
                width: 1400,
                spaceBetween : 140,
                slidesOffsetBefore: 100,
                slidesOffsetAfter: 100,
                simulateTouch: false,
                // mousewheelControl: true,
                // forceToAxis: true,
                // mousewheel: { // 鼠标轮
                //     sensitivity : 0.1,  // 滑动灵敏度
                // },
            },
            navbar: [
                {zh:'公司簡介', en:'Company Profile', id:'aa'},
                {zh:'我們的優勢', en:'Our Advantages', id:'bb'},
                {zh:'核心價值觀', en:'Core Values', id:'cc'},
                {zh:'業務介紹', en:'Our Strengths', id:'dd'},
                {zh:'聯繫我們', en:'Email', id:'ee'},
            ],
            hoverLeft: false,
            hoverRight: false,
            isMounted: false,
            isZH: true,
            seen: true,
            sliders: [],
            // 业务介绍
            showNav: false,
            navActive: '',
            ywActive: 200,
            ywList: [
                {
                    zh: '廣告二級代理服務',
                    en: 'Advertising secondary agency services',
                    cZh: '提供靈活、低成本的廣告投放資源，包括：<br>媒體採購優化：通過二級代理渠道，爲客戶爭取更高返點與優惠費率<br>賬戶管理與運營：協助開戶、充值、違規規避及日常投放優化<br>本地化支持：針對香港、新加坡市場的政策與支付適配',
                    cEn: "Provide flexible, low-cost advertising resources, including:<br>media procurement optimization: through the secondary agency channel, we strive <br>for higher rebates and preferential rates for customers<br>Account management and operation: assist in account opening, recharge, violation avoidance and daily placement optimization<br>Localization support: policy and payment adaptation for Hong Kong and Singapore markets”.",
                },
                {
                    zh: '資訊諮詢及技術支援服務',
                    en: 'Information Consultation and Technical Support Services',
                    cZh: '為企業提供客製化諮詢及技術賦能服務，涵蓋：<br>策略諮詢：數位轉型規劃與落地支持<br>系統運作與測試：保障系統穩定性與相容性<br>流程優化：透過技術驅動業務成長，提升市場競爭力',
                    cEn: "Provide customized consulting and technology-enabling services for enterprises, covering:<br>Strategic consulting: digital transformation planning and landing support<br>System operation and maintenance and testing: to ensure system stability and compatibility<br>Process optimization: driving business growth and market competitiveness through technology.",
                },
            ],
            // 企业文化
            whActive: 0,
            whList: [
                {
                    zh: '客戶至上',
                    en: 'The customer reigns supreme',
                    cZh: '以解決客戶痛點爲出髮點，提供靈活、可落地的解決方案。 注重長期合作價值，超越短期利益。',
                    cEn: "Provide flexible and implementable solutions with the starting point of solving customers' pain points.<br>Focus on the value of long-term cooperation, beyond short-term interests.",
                },
                {
                    zh: '專業爲本',
                    en: 'Professionalism is the foundation',
                    cZh: '深耕廣告代理與信息技術領域，以數據驅動決策，確保服務精準高效。<br>持續學習行業前沿，保持技術領先性與策略創新力。',
                    cEn: "Deeply plowing into the field of advertising agency and information technology, with data-driven decision-making to ensure accurate and efficient services.<br>Continuously learning from the industry's frontiers to maintain technological leadership and strategic innovation.",
                },
                {
                    zh: '協作共贏',
                    en: 'Win-Win Collaboration',
                    cZh: '內部倡導跨團隊高效協同，外部與客戶、合作夥伴共建生態價值。<br>通過透明溝通與資源整合，實現多方利益最大化。',
                    cEn: "Internally, we advocate efficient collaboration across teams, and externally, we build ecological value with customers and partners.<br>Through transparent communication and resource integration, we maximize the interests of multiple parties.",
                },
                {
                    zh: '誠信擔當',
                    en: 'Playing with Integrity',
                    cZh: '恪守商業道德，嚴守客戶數據隱私與合規底線。<br>對結果負責，承諾即交付，問題即解決。',
                    cEn: "Adhere to business ethics and the bottom line of customer data privacy and compliance. Accountable for results, delivering on promises and solving problems.",
                },
            ],
            // 我們的優勢
            ysActive: 200,
            ysList: [
                {
                    zh: '本地化經驗',
                    en: 'Localization experience',
                    cZh: '深耕香港及新加坡市場，熟悉區域商業<br>環境',
                    cEn: "Deeply cultivated in Hong Kong and <br>Singapore markets, familiar with the <br>regional business environment",
                },
                {
                    zh: '數據驅動',
                    en: 'Data-Driven',
                    cZh: '以分析為基礎，提供可量化的成長方案',
                    cEn: "Data-driven to provide quantifiable <br>growth scenarios based on analytics",
                },
                {
                    zh: '一站式服務',
                    en: 'One-Stop Service',
                    cZh: '從策略到執行，全程高效能協同',
                    cEn: "High-performance collaboration from <br>strategy to execution",
                },
            ],
            // 简介
            jjActive: 200,
            jjList: [
                {
                    zh: '使命',
                    en: 'Our Mission',
                    cZh: '以專業諮詢與創新技術賦能企業，助力客戶在數字化時代實現高效增長與品牌昇級。',
                    cEn: "To empower enterprises with professional consulting and innovative technology, and help clients achieve efficient growth and brand upgrading in the digital era.",
                },
                {
                    zh: '願景',
                    en: 'Vision',
                    cZh: '成爲亞太區最受信賴的數字化營銷與技術服務夥伴，以本地化洞察與全球化視野驅動商業成功。',
                    cEn: "To be the most trusted digital marketing and technology services partner in Asia Pacific, driving business success with local insights and global vision.",
                },
            ],
        }
    },
    methods: {
        scrollTo(type) {
            this.navActive = type;
            document.getElementById(type).scrollIntoView({ behavior: 'smooth', block: 'start'})
        },
        menuSeen(){
            // 屏幕尺寸
            let screenHeight=document.body.clientWidth;
            if(screenHeight>415){
                this.seen=true;
            }else{
                this.seen=false;
            }
        },
    },
    mounted() {
        this.isMounted = true;
        this.menuSeen();
        // window.addEventListener('resize', () => {
        //     location.reload();
        // });
        autofit.init({
            designWidth: 1920,
            designHeight: 8090,
            renderDom:"#container",
            ignore: [
                {
                    el: ".head", //必填
                    height: "100px",//可选，需注明单位
                    width: "100%",//可选，需注明单位
                    scale:1, //可选：回放程度，基于主元素缩放后的大小
                    fontSize:26 //可选，如果自定义缩放后文字大小不合适，可以在这里设置文字大小
                },
            ],
            resize: true
        },false) // 可关闭控制台运行提示输出

        // 初始化横向滚动按钮行为
        const buttons = document.querySelectorAll('.jumpButton');
        const indices = {};

        buttons.forEach(button => {
            const targetClass = button.getAttribute('data-target-class');
            indices[targetClass] = 0;

            button.addEventListener('click', () => {
                const targets = document.querySelectorAll(`.${targetClass}`);
                if (targets.length > 0) {
                    targets[indices[targetClass]].scrollIntoView({
                        behavior: 'smooth',
                        // inline: 'start'
                    });
                    indices[targetClass] = (indices[targetClass] + 1) % targets.length;
                }
            });
        });

    },
    destroyed() {
        autofit.off();
    },
    computed: {
        customswiper() {
            let swiper = {};
            if (this.isMounted) swiper = this.$refs.mySwiper.$swiper;
            return swiper;
        },
    },
}
</script>

<style scoped>
@import './index.css';
.btn {
    background: #EA3F30;border-radius: 100px;padding: 4px 10px;font-size: 24px;font-weight: bold;
}
.more {
    border-radius: 42px;border: 2px solid #222222;width: 215px;height:67px;line-height:67px;text-align:center;font-size: 21px;
}
.navbar {
    color:white;font-family: Arial, Arial;font-weight: 900;font-size: 22px;color: #fff;
}
.nav {
    font-family: Inter, Inter;font-weight: 400;font-size: 20px;color: #000000;
}
.nav-active {
    font-weight: bold;
}
.navbar-t {
    text-align:center;
    font-family: Poppins, Poppins;
    font-weight: 400;
    font-size: 100px;
    color: #FFFFFF;
    line-height: 140px;
}
.navbar-c {
    text-align:center;
    font-family: Poppins, Poppins;font-size: 32px;color: #DDDDDD;line-height: 51px;font-weight: 400;
}
.navbar-b {
    background: #EA3F30;border-radius: 24px;padding: 29px 44px;font-size: 29px;font-weight: 500;color: #FFFFFF;
}
.navbar-bg{
    width: 100%;
    height: 100%;
    background: url('../../static/b/navbar-bg.png');
    background-size: 100% 100%;
}
.main-m {
    width: 40px;height: 12px;background: #EA3F30;border-radius: 100px;margin-bottom: 20px;
}
.main-t {
    width:100%;font-family: Manrope, Manrope;font-weight: 600;font-size: 30px;color: #1A1A1A;line-height: 72px;
}
.main-c {
    font-family: Manrope, Manrope;font-weight: 400;font-size: 56px;color: #1A1A1A;line-height: 72px;
}
.sub-t {
    width:100%;font-family: Manrope, Manrope;font-weight: bold;font-size: 56px;color: #000000;line-height: 80px;
}
.sub-c {
    width:100%;font-family: Manrope, Manrope;font-weight: 400;font-size: 30px;color: #A4A4A4;line-height: 45px;margin-top: 20px;
}
.menu {
    width:20px;position:absolute;right:24px;top:50%;transform:translateY(-50%);
}

.carousel {
  display: flex;
  /* overflow: hidden; */
  width: 300px;
  height: 100px;
  position: relative;
}

.carousel-item {
  flex: 0 0 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f0f0f0;
  border: 1px solid #000;
  box-sizing: border-box;
  transition: transform 0.5s ease-in-out;
}

.carousel-item.slide {
  transform: translateX(-100%);
}
.horizontal-scroll-container {
  display: flex;
  overflow-x: auto;
  scroll-behavior: smooth;
  white-space: nowrap;
  padding-top: 20px;
  /* 隐藏滚动条 */
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE 10+ */
}
.horizontal-scroll-container::-webkit-scrollbar {
  display: none; /* 隐藏滚动条（WebKit/Blink） */
}

.horizontal-slide {
  width: 90%;
  min-width: 1000px; /* 避免缩放 */
  margin-right: 20px;
  flex-shrink: 0;
}

.horizontal-swiper {
  width: 100%;
  /* overflow: hidden; */
}

.swiper-container-horizontal > .swiper-wrapper {
  flex-direction: row; /* 强制横向排列 */
}
.swiper-button-next:after {
display: none;
}
.swiper-button-prev:after {
display: none;
}
</style>